import React from 'react';
import { Text } from '@shoutem/ui';

function Br() {
  return (
    <Text>
      {"\n"}
    </Text>
  );
}

export default Br;



// WEBPACK FOOTER //
// ./node_modules/@shoutem/ui/html/elements/Br.js